<template>
    <section class="funcContainer">
        <p>Referências Criadas:</p>
        <span v-if="this.references == undefined || this.references.length == 0">Nenhuma referência encontrada.</span>
        <section class="referencesContainer">
            <p class="funcRef" v-for="(refCModal, idxModal) in this.references" :key="`${refCModal}-${idxModal}-modal`"
                draggable="true" @dragstart="refDrag($event, refCModal)" @click.prevent="addRefToCondit(refCModal)">
                {{ refCModal.label }}
            </p>
        </section>
        <section v-if="hasCondition" class="conditionalContainer">
            <p>Definição da Condicional:</p>
            <span><strong>*</strong> <strong>Clique</strong> nas <strong>referências</strong> acima e nos
                <strong>operadores</strong> abaixo para montar a condicional.</span>
            <section class="logicalsItens">
                <p class="logics" v-for="(logic, idx) in this.logicComponents" :key="`${logic.label}-${idx}`"
                    @click.prevent="handleLogic(logic)">{{ logic.label }}</p>
            </section>
            <section class="conditShowContainer">
                <section class="conditionsToShow">
                    <p class="conditionExp" v-for="(cond, idx) in this.conditonsCreated" :key="`${cond.label}-${idx}-cond`">
                        {{ cond.label }}</p>
                </section>
                <p class="clearCond" title="Limpar" @click.prevent="clearCondit">X</p>
            </section>
        </section>
        <span class="tipFunc"><strong>*</strong> <strong>Arraste</strong> as <strong>referências</strong> para preencher os
            campos abaixo e montar a expressão.</span>
        <section class="fieldsContent">
            <section v-for="(field, idxF) in this.fields" :key="idxF" class="dropSection">
                <label :for="`drop-value-${idxF}`">
                    <span>Valor: <span class="cleanInput" @click.prevent="clearInput(idxF, 'value')">Limpar</span></span>
                    <input readonly type="text" placeholder="Valor" :id="`drop-value-${idxF}`"
                    @dragleave.prevent="refLeave(idxF, 'value')" @dragenter="refEnter(idxF, 'value')"
                    @drop="refDrop($event, idxF, 'value')" @dragover.prevent @dragenter.prevent :value="field.value" />
                </label>
                <label v-if="field.hasWeight == true" :for="`drop-weight-${idxF}`">
                    <span>Peso: <span class="cleanInput" @click.prevent="clearInput(idxF, 'weight')">Limpar</span></span>
                    <input readonly type="text" placeholder="Peso" v-if="field.hasWeight == true"
                        :id="`drop-weight-${idxF}`" @dragenter="refEnter(idxF, 'weight')"
                        @dragleave.prevent="refLeave(idxF, 'weight')" @drop="refDrop($event, idxF, 'weight')"
                        @dragover.prevent @dragenter.prevent :value="field.weight" />
                </label>
            </section>
        </section>
        <section class="fieldsBtn">
            <button @click="removeField" id="removeField">Remover Campo</button>
            <button @click="addNewField" id="addField">Adicionar Campo</button>
        </section>
        <button @click="finishEquation" id="finishExp">Finalizar Expressão</button>
    </section>
</template>
<script>
import MediatorIndicatorEditor from '../MediatorIndicatorEditor';

export default {
    name: 'ModalProps',
    props: {
        modalType: String,
        addFunc: Function,
        references: Array,
        hasCondition: Boolean,
        needWeight: Boolean,
    },
    data() {
        return {
            fields: [],
            conditonsCreated: [],
            logicComponents: [
                { label: '=', type: 'operation' },
                { label: '<>', type: 'operation' },
                { label: '<', type: 'operation' },
                { label: '>', type: 'operation' },
                { label: '<=', type: 'operation' },
                { label: '>=', type: 'operation' },
                { label: 'AND', type: 'operation' },
                { label: 'OR', type: 'operation' },
                { label: '-9999', type: 'operation' },
                { label: '0', type: 'operation' },
            ],
            openParentese: { label: '(', type: 'operation' },
            closeParentese: { label: ')', type: 'operation' },
            doubleDot: { label: ':', type: 'operation' },
            comma: { label: ',', type: 'operation' },
            addedInfos: [],
        }
    },
    methods: {
        addNewField() {
            let fieldObj = { hasWeight: false, weight: '', value: '', structureVal: {}, structureWeight: {} }

            if (this.needWeight == true) fieldObj.hasWeight = true;

            this.fields = [
                ...this.fields,
                fieldObj
            ]
        },

        removeField() {
            this.fields.pop();
        },

        finishEquation() {
            let fieldsInfos = []
            let hasEmpty = false;

            this.fields.forEach((field, idx, arr) => {
                if (field.value != '' || field.weight != '') {
                    fieldsInfos.push({ label: field.value, type: 'reference', structure: field.structureVal });

                    if (field.hasWeight == true) {
                        fieldsInfos.push(this.doubleDot);
                        fieldsInfos.push({ label: field.weight, type: 'reference', structure: field.structureWeight });
                    }

                    if (idx < arr.length - 1) {
                        fieldsInfos.push(this.comma);
                    }
                } else {
                    hasEmpty = true;
                }
            })

            if (hasEmpty == true) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Campos Vazios', 'Preencha todos os campos antes de confirmar a operação.');
                return;
            }

            let buildExp = []

            if (fieldsInfos.length > 0) {
                if (this.hasCondition == true) {
                    this.conditonsCreated.unshift({ label: "'", type: 'operation' })
                    this.conditonsCreated.push({ label: "'", type: 'operation' })
                    this.conditonsCreated.push({ label: ",", type: 'operation' })
                    fieldsInfos.unshift(...this.conditonsCreated)
                }

                buildExp = [
                    { label: this.modalType, type: 'operation' },
                    this.openParentese,
                    ...fieldsInfos,
                    this.closeParentese,
                ]

            }

            this.addFunc(buildExp)
        },

        refDrag(evt, ref) {
            evt.dataTransfer.setData('refJSON', JSON.stringify(ref));
        },

        refEnter(fieldId, type) {
            let element = document.getElementById(`drop-${type}-${fieldId}`);
            element.style.borderColor = "#00A39F";
        },

        refLeave(fieldId, type) {
            let element = document.getElementById(`drop-${type}-${fieldId}`);
            element.style.borderColor = "#4f4f4f";
        },

        refDrop(evt, fieldId, type) {
            let element = document.getElementById(`drop-${type}-${fieldId}`);
            element.style.borderColor = "#00A39F";
            element.style.color = "#fff";
            element.style.backgroundColor = "#00A39F";

            let refJSON = JSON.parse(evt.dataTransfer.getData('refJSON'));

            if (type == 'weight') {
                this.fields[fieldId].weight = refJSON.label
                this.fields[fieldId].structureWeight = refJSON
            } else {
                this.fields[fieldId].value = refJSON.label
                this.fields[fieldId].structureVal = refJSON
            }
        },

        handleLogic(logic) {
            this.conditonsCreated.push(logic);
        },

        addRefToCondit(ref) {
            this.conditonsCreated.push({ label: ref.label, type: 'reference', structure: ref });
        },

        clearCondit() {
            this.conditonsCreated = []
        },

        clearInput(fieldId, type) {
            let element = document.getElementById(`drop-${type}-${fieldId}`);
            element.style.borderColor = "#4f4f4f";
            element.style.color = "#555555";
            element.style.backgroundColor = "#fff";

            if (type == 'weight') {
                this.fields[fieldId].weight = ''
                this.fields[fieldId].structureWeight = {}
            } else {
                this.fields[fieldId].value = ''
                this.fields[fieldId].structureVal = {}
            }
        }
    },

    created() {
        let fieldObj = { hasWeight: false, weight: '', value: '', structureVal: {}, structureWeight: {} }

        if (this.needWeight == true) fieldObj.hasWeight = true;

        let newObj = {...fieldObj}

        this.fields.push(fieldObj, newObj)
    }
}
</script>
<style scoped>
.funcContainer {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
}

.dropSection {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.3rem;
    row-gap: 0.3rem;
}

.dropSection label {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    /* row-gap: 0.1rem; */
}

.dropSection label input {
    width: 100%;
    border: 1px solid #4f4f4f;
    border-radius: 0.2rem;
}

.fieldsContent {
    /* margin: 0.5rem 0; */
    overflow-y: auto;
    max-height: 13rem;
    padding: 0 0.2rem;
}

.funcRef {
    cursor: pointer;
    user-select: none;
    padding: 0.5rem;
    height: 1.5rem;
    width: max-content;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #FBFBFB;
    color: #555555;
    border: 0.12rem solid #00A39F;
    border-radius: 0.3rem;
    font-size: 0.9rem;
}

.referencesContainer {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 0.3rem;
    row-gap: 0.3rem;
    margin-top: 0.2rem;
}

.conditionalContainer {
    border: 1px dashed rgb(173, 173, 173);
    border-radius: 0.2rem;
    padding: 0.2rem;
    margin-top: 0.5rem;
}

.logicalsItens {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 0.1rem;
    row-gap: 0.1rem;
}

.logics {
    font-size: 0.7rem;
    border: 0.12rem solid #0000002a;
    border-radius: 0.3rem;
    color: #555555;
    background-color: #EFEFEF;
    width: 2.5rem;
    height: 1.5rem;
    padding: 0.1rem;
    text-align: center;
    cursor: pointer;
    user-select: none;
}

.logics:hover {
    filter: brightness(98%);
}

.conditionsToShow {
    height: 2.5rem;
    max-height: 6rem;
    width: 100%;
    overflow-y: auto;
    background-color: #ebebeb;
    border: 1px dashed gray;
    border-radius: 0.2rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    row-gap: 0.3rem;
    column-gap: 0.3rem;
    padding: 0 0.3rem;
    position: relative;
    user-select: none;
}

.conditionExp {
    background-color: #fff;
    font-size: 0.9rem;
    border-radius: 0.2rem;
    padding: 0.2rem;
    border: 1px solid black;
    user-select: none;
}

button {
    width: 100%;
    border: 1px solid #ffb285;
    color: #ffb285;
    border-radius: 0.2rem;
    background-color: #fff;
    font-weight: 500;
}

button:hover {
    filter: brightness(98%);
}

#finishExp {
    padding: 0.4rem;
    color: #fff;
    background-color: #FF5F00;
    margin-top: 2rem;
}

p {
    font-size: 1rem;
    font-weight: 500;
    margin: 0;
}

span {
    font-weight: 400;
    font-size: 0.9rem;
    color: #555555;
    margin: 0.3rem 0;
}

strong {
    color: #FF5F00;
}

.tipFunc {
    margin: 0.3rem 0;
}

.fieldsBtn {
    display: flex;
    column-gap: 0.3rem;
}

#addField {
    border-color: #00A39F;
    color: #00A39F;
}

#removeField {
    border-color: #ff4f5a;
    color: #ff4f5a;

}

.conditShowContainer {
    display: flex;
    align-items: center;
    column-gap: 0.2rem;
    justify-content: center;
    margin-top: 0.8rem;

}

.clearCond {
    /* position: absolute; */
    height: max-content;
    width: max-content;
    border: 1px dashed #fff;
    padding: 0 0.3rem;
    color: #fff;
    margin: 0;
    background-color: #ff4f5a;
    font-size: 0.7rem;
    border-radius: 100%;
    cursor: pointer;
    user-select: none;
}

.cleanInput {
    font-size: 0.8rem;
    color: #02918e;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
}
</style>